import { useContext } from 'react'
import { useParams } from 'react-router-dom'

import GeoContext from 'contexts/geoContext'

const normalizeRegionCode = (regionCode?: string | null) =>
  regionCode?.trim() ? regionCode.trim().toUpperCase() : ''

export default function useWishlistRegionCode() {
  const { currentRegionCode } = useContext(GeoContext)
  const { regionCode } = useParams<{ regionCode?: string }>()

  return normalizeRegionCode(regionCode) || normalizeRegionCode(currentRegionCode)
}
